import { render, staticRenderFns } from "./SweetAlertTypes.vue?vue&type=template&id=9c4b0d0e"
import script from "./SweetAlertTypes.vue?vue&type=script&lang=js"
export * from "./SweetAlertTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports